import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect } from "react";
import { FullHeightLoading } from "../App.style";
import { useNavigate } from "react-router-dom";

export const Callback: React.FC = () => {
  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    } else {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return <FullHeightLoading />;
};
